import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../authentication.service";
import { ClientService } from "../../services/client.service";
import { ErrorService } from "../../services/error.service";
import { AccountsService } from "../../services/accounts.service";
import { CustomValidators } from "../../validators/custom-validators.validator";
import { FlashService } from "../../flash/flash.service";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { environment } from "../../../environments/environment";
import { CredentialResponse, PromptMomentNotification } from "google-one-tap";
import { ActivatedRoute } from '@angular/router';

// @ts-ignore
declare var window: any;
declare const gapi: any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  forgotPasswordForm: FormGroup;

  private clientId = environment.google_login_client_id;
  private microsoftClientId = environment.microsoft_login_client_id;
  public auth2: any;
  txts;
  index = 0;
  setIntervalId;
  
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    private clientservice: ClientService,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
    private errorService: ErrorService,
    private accountsService: AccountsService,
    private ng_zone: NgZone,
    private route: ActivatedRoute
  ) {}

  currentUser;
  emailPattern = "[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}";
  @ViewChild("closeModal") close: ElementRef;

  ngOnInit() {
    this.setupMicrosoftSignIn();
    this.animateText();
  }

  ngOnDestroy() {
    if (this.setIntervalId) {
      clearInterval(this.setIntervalId);
    }
  }

  animateText() {
    if (!this.setIntervalId)
      this.setIntervalId = setInterval(this.animateText, 3000);
    if (!this.txts) this.txts = document.querySelector(".animate-txt").children;
    if (!this.index) this.index = 0;

    for (let i = 0; i < this.txts.length; i++) {
      this.txts[i].classList.remove("text-in");
    }

    this.txts[this.index].classList.add("text-in");

    if (this.index == this.txts.length - 1) {
      this.index = 0;
    } else {
      this.index++;
    }
  }

  private setupMicrosoftSignIn() {
    const msLoginButton = document.getElementById("microsoftLoginButton");
    msLoginButton.addEventListener("click", this.loginWithMicrosoft.bind(this));
  }

  loginWithMicrosoft() {
    const authUrl =
      'https://login.microsoftonline.com/2a4a5a22-099a-4115-86f7-35b1367f0ea9/oauth2/authorize' +
      '?response_type=id_token' +
      '&client_id=' + this.microsoftClientId +
      '&redirect_uri=' + encodeURIComponent(window.location.origin +'/sso-handler') +
      '&scope=openid profile email' +
      '&nonce=' + Math.floor(Math.random() * 100000).toString();
    window.location.replace(authUrl);
  }

  // handleCredentialResponse(response: CredentialResponse) {
  //   let bodyData = { token: response["credential"] };
  //   this.authenticationService.signInWithGoogle(bodyData).subscribe(
  //     (data) => {
  //       this.spinnerService.hide();
  //       this.ng_zone.run(() => {
  //         if (data.body.hasOwnProperty("success") && !data.body["success"]) {
  //           this.flashService.show(data.body["message"], "alert-danger");
  //         } else {
  //           this.setupSigInData(data);
  //         }
  //       });
  //     },
  //     (error) => {
  //       this.spinnerService.hide();
  //       this.flashService.show(error.error.errors[0], "alert-danger");
  //       this.authenticationService.changeLogin(false);
  //       this.errorService.errorHandling(error);
  //     }
  //   );
  // }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/authentication/login/login.component.ts